import CONNECT_BA from '@/graphql/Website/connectBingAds.gql';
import SET_BA from '@/graphql/Website/setBingAds.gql';
import { authClient } from '../main'

export default class GaResource {
    async connect (websiteId) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: CONNECT_BA,
            variables: {
                websiteId: websiteId
            }
        })
    }

    async set (code) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: SET_BA,
            variables: {
                websiteId: $cookies.get('website_id'),
                code: code
            }
        })
    }
}